<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [class]="size"
>
  <use [attr.xlink:href]="link" [attr.href]="link" />
</svg>
